import { useGuestMutations, type Guest } from "@/hooks/useGuests";
import { useState } from "react";

const useGuestModal = () => {
  const [guestToEdit, setGuestToEdit] = useState<Guest | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeletingGuest, setIsDeletingGuest] = useState<Guest | null>(null);

  const { deleteGuest } = useGuestMutations();

  const openCreateModal = () => {
    setGuestToEdit(null);
    setIsModalOpen(true);
  };

  const openEditModal = (guest: Guest) => {
    setGuestToEdit(guest);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setGuestToEdit(null);
    setIsModalOpen(false);
  };

  const handleDeleteGuest = async (guest: Guest) => {
    if (window.confirm("¿Estás seguro de que quieres eliminar este huésped?")) {
      setIsDeletingGuest(guest);
      try {
        await deleteGuest.mutateAsync(guest.id);
      } finally {
        setIsDeletingGuest(null);
      }
    }
  };

  const isEditingGuest = Boolean(guestToEdit);

  return {
    guestToEdit,

    isModalOpen,
    isEditingGuest,
    isDeletingGuest,

    openCreateModal,
    openEditModal,
    closeModal,
    handleDeleteGuest,
  };
};

export default useGuestModal;
